import BigNumber from 'bignumber.js'
import React, {useCallback, useMemo, useState} from 'react'
import Button from '../../../components/Button'
import Modal, {ModalProps} from '../../../components/Modal'
import ModalActions from '../../../components/ModalActions'
import ModalTitle from '../../../components/ModalTitle'
import TokenInput from '../../../components/TokenInput'
import {getFullDisplayBalance} from '../../../utils/formatBalance'
import {StylePadding} from "./DepositModal";

interface WithdrawModalProps extends ModalProps {
    max: BigNumber
    onConfirm: (amount: string) => void
    tokenName?: string
}

const WithdrawModal: React.FC<WithdrawModalProps> = ({
                                                         onConfirm,
                                                         onDismiss,
                                                         max,
                                                         tokenName = '',
                                                     }) => {
    const [val, setVal] = useState('');
    const [pendingTx, setPendingTx] = useState(false);

    const fullBalance = useMemo(() => {
        return getFullDisplayBalance(max.times(4))
    }, [max]);

    const handleChange = useCallback(
        (e: React.FormEvent<HTMLInputElement>) => {
            setVal(e.currentTarget.value)
        },
        [setVal],
    );

    const handleSelectMax = useCallback(() => {
        setVal(fullBalance)
    }, [fullBalance, setVal]);

    return (
        <Modal>
            <StylePadding>
                <ModalTitle text={`Withdraw from ${tokenName} Pool`}/>
                <TokenInput
                    onSelectMax={handleSelectMax}
                    onChange={handleChange}
                    value={val}
                    max={fullBalance}
                    symbol="Staking Power"
                />
                <ModalActions>
                    <Button text="Cancel" variant="secondary"  color="#2765A6" bGColor="#17254A" size="sm"  onClick={onDismiss}/>
                    <Button
                        disabled={pendingTx}
                        text={pendingTx ? 'Pending Confirmation' : 'Confirm'}
                        size="sm"
                        onClick={async () => {
                            // setPendingTx(true);
                            onDismiss();

                            await onConfirm(val);
                            // setPendingTx(false);
                        }}
                    />
                </ModalActions>
            </StylePadding>

        </Modal>
    )
};

export default WithdrawModal
